var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"footer-inner"},[_c('p',[_vm._v("© 2026 origami-skin. All rights reserved.")]),_c('div',{staticClass:"footer-links"},[_c('router-link',{attrs:{"to":"/privacy"}},[_vm._v("Privacy Policy")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }